import { siteConfig } from "@/lib/site-config";

export interface SeoProps {
  title: string;
  description: string;
  path: string;
  ogType?: "website" | "article";
  ogImage?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
}

/** Fully resolved head metadata for one page. Shared by the client and the prerender. */
export interface ResolvedSeo {
  title: string;
  description: string;
  url: string;
  image: string;
  ogType: "website" | "article";
  noindex: boolean;
  jsonLd: Record<string, unknown>[];
}

export function resolveSeo({ title, description, path, ogType = "website", ogImage, jsonLd, noindex }: SeoProps): ResolvedSeo {
  const image = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${siteConfig.url}${ogImage}`
    : `${siteConfig.url}${siteConfig.ogImage}`;
  return {
    title,
    description,
    url: `${siteConfig.url}${path}`,
    image,
    ogType,
    noindex: !!noindex,
    jsonLd: jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [],
  };
}
